/**
 * External dependencies
 */
import Swiper from 'swiper/bundle';
import 'swiper/css';

/**
 * Swiperを初期化
 */
function initSwiper() {
	const sliders = document.querySelectorAll(
		'.wp-block-best-anniversary-blocks-learn-more__right'
	);

	sliders.forEach((right) => {
		const block = right.closest(
			'.wp-block-best-anniversary-blocks-learn-more'
		);
		if (!block) {
			return;
		}

		const prevBtn = block.querySelector(
			'.wp-block-best-anniversary-blocks-learn-more__prev'
		);
		const nextBtn = block.querySelector(
			'.wp-block-best-anniversary-blocks-learn-more__next'
		);

		new Swiper(right, {
			slidesPerView: 'auto',
			spaceBetween: 24,
			speed: 600,
			watchOverflow: true,
			navigation: {
				prevEl: prevBtn,
				nextEl: nextBtn,
				disabledClass: 'is-disabled',
				lockClass: 'is-locked',
			},
			a11y: {
				prevSlideMessage: '前のスライド',
				nextSlideMessage: '後のスライド',
			},
		});
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initSwiper);
} else {
	initSwiper();
}
